import React from 'react';
import T from 'prop-types';
import { StyledContentWrapper } from '../../../../components/forms/Machines/MachineDetail/elements';
import ConnectedStatusContent from './ConnectedStatusContent';

const Status = ({ plcType }) => (
  <>
    <StyledContentWrapper elevation={3}>
      <ConnectedStatusContent plcType={plcType} />
    </StyledContentWrapper>
  </>
);

Status.propTypes = {
  plcType: T.shape({
    plc_type: T.string,
    autoconfig_enabled: T.bool
  }).isRequired
};

export default Status;
